
import Vue from "vue";
import { IEvent } from "../store/state";

// Interfaces for component typechecking!
interface EventData {}

interface EventMethods {}

interface EventComputed {}

interface EventProps {
  event: IEvent;
}

export default Vue.extend<EventData, EventMethods, EventComputed, EventProps>({
  name: "Event",
  props: {
    event: {},
  },
  computed: {},
  components: {},
});
